import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the TableOwnersIncomeReports view.
 */
export default class TableOwnersIncomeReports extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Returns formatted percentage
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            id: 'datatable', // ID for the datatable
                            view: 'datatable', // Webix datatable view
                            scroll: 'xy', // Enables both horizontal and vertical scrolling
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha'), // Column header with localization
                                    width: 200, // Column width
                                    format: dateFormat, // Date format for the column
                                },
                                {
                                    id: 'UniqueTransactionId', // Column ID
                                    header: _('Identificador único de la transacción'), // Column header
                                    width: 250, // Column width
                                },
                                {
                                    id: 'PlayerId', // Column ID
                                    header: _('Identificador único del jugador'), // Column header
                                    width: 250, // Column width
                                },
                                {
                                    id: 'BetStatus', // Column ID
                                    header: _('Estado de la apuesta'), // Column header with localization
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Bet', // Column ID
                                    header: _('Apuesta'), // Column header
                                    width: 300, // Column width
                                },
                                {
                                    id: 'Award', // Column ID
                                    header: _('Premio'), // Column header
                                    width: 300, // Column width
                                },
                                {
                                    id: 'Odds', // Column ID
                                    header: _('Cuota'), // Column header
                                    width: 150, // Column width
                                },
                                {
                                    id: 'SelectedQuantity', // Column ID
                                    header: _('Cantidad de Selecciones'), // Column header with localization
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo'), // Column header with localization
                                    width: 200, // Column width
                                },
                                {
                                    id: 'TicketDate', // Column ID
                                    header: _('Fecha de ticket'), // Column header with localization
                                    width: 250, // Column width
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Date format for the column
                                },
                                {
                                    id: 'CalculationDate', // Column ID
                                    header: _('Fecha de cálculo'), // Column header with localization
                                    width: 250, // Column width
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Date format for the column
                                },
                            ],
                            on: {
                                /**
                                 * Event handler for before loading data.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Event handler for after loading data.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hides the loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Checks if there are no data entries
                                    webix.extend(this, webix.OverlayBox); // Extends with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Shows no data overlay
                                }
                            },
                            autowidth: false, // Disables automatic width adjustment
                            math: true, // Enables mathematical operations
                            datafetch: 10, // Number of data items to fetch at once
                            pager: 'pagerA', // ID of the pager component
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Gets the datatable instance
        let url = devConfig.geturlApi() + 'es/Financial/GetIncomeFirstLevel'; // API endpoint for data fetching

        /**
         * Event handler for filtering data based on user input.
         * @param {Object} filterData - The filter criteria.
         */
        this.on(this.app, 'ownersIncome:filter', (filterData) => {
            let object = Object.entries(filterData); // Converts filter data to entries
            let string1 = ''; // Query string for API request

            for (let i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        let date = object[i][1].split(' - '); // Splits date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Adds dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Adds dateTo to query
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Adds other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                let date = object[i][1].replace(' 00:00:00', ''); // Formats date
                                string1 = string1 + '&dateFrom=' + date; // Adds dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Adds dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        let object2 = Object.entries(object[i][1]); // Converts nested filter data to entries
                        for (let j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    let d = new Date(object2[j][1]); // Creates date object for start date
                                    let dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Adds start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        let d = new Date(object2[j][1]); // Creates date object for end date
                                        let dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Adds end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clears existing data in the grid
            $$('consultDesk').define('disabled', true); // Disables the consult desk during loading
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1) // Loads data with the constructed query
                .then((response) => {
                    $$('consultDesk').define('disabled', false); // Re-enables the consult desk after loading
                })
                .catch((e) => {
                    $$('consultDesk').define('disabled', false); // Re-enables the consult desk on error
                });
            $$('filterPopup').hide(); // Hides the filter popup
        });

        $$('pagerA').attachEvent('onAfterPageChange', function (page) {
            webix.delay(
                function () {
                    if (page != '0') {
                        chargeTable(); // Calls chargeTable if the page is not the first
                    }
                },
                '',
                '',
                100,
            );
        });

        /**
         * Event handler for changing the size of the view.
         * @param {Object} filterData - The filter criteria.
         */
        this.on(this.app, 'changeSize', (filterData) => {
            chargeTable(); // Calls chargeTable on size change
        });

        /**
         * Loads data into the grid based on pagination.
         */
        function chargeTable() {
            let size = grid.getPager().config.size; // Gets the page size
            let page = grid.getPage(); // Gets the current page
            let first = size * page; // Calculates the starting index
            let last = first + size - 1; // Calculates the ending index
            grid.load(url + '?start=' + first + '&count=' + (last + 1) + filter); // Loads data with pagination
        }
    }
}

// FILE DOCUMENTED
